export default {
  empty: {
    EN: "No jobs found",
  },
  "update-job-project-manager-success": {
    EN: "Project manager updated successfully!",
  },
  "update-job-project-manager-failure": {
    EN: "Could not update project manager",
  },
  "update-job-billing-status-success": {
    EN: "Billing status updated successfully!",
  },
  "update-job-billing-status-failure": {
    EN: "Could not update billing status",
  },
  "update-job-deposit-status-success": {
    EN: "Deposit collection status updated.",
  },
  "update-job-deposit-status-failure": {
    EN: "Could not update deposit collection status. Please try again.",
  },
  "update-job-notes-success": {
    EN: "Job notes updated successfully!",
  },
  "update-job-notes-failure": {
    EN: "Could not updatejob notes",
  },
  "update-job-project-file-folder-id-success": {
    EN: "Updated!",
  },
  "update-job-project-file-folder-id-failure": {
    EN: "Something went wrong",
  },
  "update-job-external-id-success": {
    EN: "Job number updated successfully",
  },
  "update-job-external-id-failure": {
    EN: "Could not update job number",
  },
  "update-checklist-items-success": {
    EN: "Job checklist items updated successfully",
  },
  "update-checklist-items-failure": {
    EN: "Failed to update job checklist items",
  },
  "update-job-status-success": {
    EN: "Job status updated successfully!",
  },
  "update-job-status-failure": {
    EN: "Could not update job status",
  },
};
